import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

export default function Navbar() {
  const { i18n } = useTranslation();
  const [isScrolled, setIsScrolled] = useState(false);
  const [isLangOpen, setIsLangOpen] = useState(false);

  // Guard against i18n being undefined for robustness
  const currentLang = i18n?.language === 'en' ? 'EN' : 'ES';

  // Removed TypeScript type annotation for plain JavaScript compatibility
  const changeLanguage = (lang) => {
    if (!i18n) return; // safety check
    i18n.changeLanguage(lang).catch((err) => {
      console.error('Failed to change language:', err);
    });
    setIsLangOpen(false);
  };

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-white shadow-md' : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-end items-center h-14 md:h-20">
          {/* Language Selector */}
          <div className="relative">
            <button
              onClick={() => setIsLangOpen(!isLangOpen)}
              className={`flex items-center space-x-1 text-xs md:text-sm font-medium transition-colors cursor-pointer px-2 py-1.5 md:px-3 md:py-2 rounded-lg ${
                isScrolled
                  ? 'text-gray-700 hover:bg-gray-100'
                  : 'text-white hover:bg-white/10'
              }`}
            >
              <i className="ri-global-line text-base md:text-lg"></i>
              <span>{currentLang}</span>
              <i
                className={`ri-arrow-down-s-line transition-transform ${
                  isLangOpen ? 'rotate-180' : ''
                }`}
              ></i>
            </button>

            {isLangOpen && (
              <div className="absolute right-0 mt-2 w-32 bg-white rounded-lg shadow-xl border border-gray-100 overflow-hidden">
                <button
                  onClick={() => changeLanguage('es')}
                  className={`w-full px-4 py-3 text-left text-sm hover:bg-gray-50 cursor-pointer flex items-center justify-between ${
                    i18n?.language === 'es'
                      ? 'text-[#F97316] font-medium'
                      : 'text-gray-700'
                  }`}
                >
                  <span>Español</span>
                  {i18n?.language === 'es' && <i className="ri-check-line"></i>}
                </button>
                <button
                  onClick={() => changeLanguage('en')}
                  className={`w-full px-4 py-3 text-left text-sm hover:bg-gray-50 cursor-pointer flex items-center justify-between ${
                    i18n?.language === 'en'
                      ? 'text-[#F97316] font-medium'
                      : 'text-gray-700'
                  }`}
                >
                  <span>English</span>
                  {i18n?.language === 'en' && <i className="ri-check-line"></i>}
                </button>
              </div>
            )}
          </div>
        </div>
      </div>
    </nav>
  );
}
